import Ani from './Ani';

export function AgileLoginInit() {
    setupPopup();
}

function setupPopup() {
    const popUp = document.getElementById('popup-agile-login');
    if (popUp) {
        popUp.addEventListener('click', (e) => {
            if (e.target !== popUp) {
                return;
            }
            e.preventDefault();
            Ani.fadeOut(popUp);
        });
    }

    const loginButtons = [...document.querySelectorAll('button[data-type=agile-login]')];
    loginButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            Ani.fadeIn(popUp);
        });
    });
}
